<template lang="pug">
  .component-backoffice-note-list.row.column
    base-list(:component="component", :dataLoader="loadZones", ref="baseList")
</template>

<script>

  import MaggieHelper from "../../maggieHelper";
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import BaseList from "./BaseList";

  export default {
    name: "NoteList",
    components: {BaseList},
    data() {
      return {

        note: {type: 'App\\Models\\Vehicle', id: null, description: null},
        component: require('src/components/backoffice/Note'),
      }

    },
    created() {
    },
    methods: {
      loadZones(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.notes.list(page, resultsPerPage).all("App\\Models\\Vehicle", (data) => {
          callback(data)
        })
      },
    }
  }
</script>

<style scoped lang="sass">
  .component-backoffice-zone-list
    .map
      height: 400px
    .zone-edit
      color: white

</style>



// WEBPACK FOOTER //
// NoteList.vue?5ef62d3e